import { clsx } from 'clsx';
import { useAuthStore } from '@shared/stores/authStore';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useCredentials, useDeleteCredentials } from '../hooks/useCredentials';
import { CredentialsForm } from '../components/CredentialsForm';
import { BitrixCatalogSelector } from '../components/BitrixCatalogSelector';
import { SubscriptionStatus } from '../components/SubscriptionStatus';
import { TelegramConnectCard } from '../components/TelegramConnectCard';
export function SettingsPage() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const { isBitrix24 } = useBitrix24();
  const { data, isLoading } = useCredentials();
  const deleteCredentials = useDeleteCredentials();

  const bitrixCred = data?.credentials?.find((c) => c.marketplace === 'bitrix');

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Settings</h2>

      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Account</h3>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">
              Signed in as <span className="font-medium text-gray-900">{user?.email}</span>
            </p>
            {user?.name && <p className="text-sm text-gray-500">{user.name}</p>}
          </div>
          {!isBitrix24 && (
            <button onClick={logout} className="btn btn-outline text-sm">
              Sign out
            </button>
          )}
        </div>
      </div>

      {isBitrix24 && <SubscriptionStatus />}
      {isBitrix24 && <TelegramConnectCard />}

      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {isBitrix24 ? 'Portal Configuration' : 'Bitrix Credentials'}
        </h3>

        {isBitrix24 ? (
          <BitrixCatalogSelector />
        ) : (
          <>
            {bitrixCred && (
              <div className="flex items-center gap-2 mb-4">
                <span
                  className={clsx(
                    'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
                    bitrixCred.isValid && 'bg-green-100 text-green-800',
                    !bitrixCred.isValid && bitrixCred.isConfigured && 'bg-red-100 text-red-800',
                    !bitrixCred.isConfigured && 'bg-gray-100 text-gray-800'
                  )}
                >
                  {bitrixCred.isValid
                    ? 'Valid'
                    : bitrixCred.isConfigured
                      ? 'Invalid'
                      : 'Not configured'}
                </span>
                {bitrixCred.lastValidatedAt && (
                  <span className="text-xs text-gray-500">
                    Last validated: {new Date(bitrixCred.lastValidatedAt).toLocaleDateString()}
                  </span>
                )}
              </div>
            )}
            {isLoading ? (
              <p className="text-sm text-gray-500">Loading credentials...</p>
            ) : (
              <CredentialsForm />
            )}
            {bitrixCred && (
              <div className="mt-4 pt-4 border-t">
                <button
                  onClick={() => {
                    if (
                      window.confirm('Delete Bitrix credentials? This will disconnect your store.')
                    ) {
                      deleteCredentials.mutate();
                    }
                  }}
                  disabled={deleteCredentials.isPending}
                  className="text-sm text-red-600 hover:text-red-800"
                >
                  {deleteCredentials.isPending ? 'Deleting...' : 'Delete credentials'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
